module.exports = __webpack_public_path__ + "static/media/attention-icon.93f20fdb.svg";